<template>
  <v-row>
    <v-col cols="12">
      <h2 @click="playSound()">{{ $t("ranking.head") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t("ranking.head_list") }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span>
              <date-picker-input ref="startDate" :label="$t('user.register_date_from')" :date="startDate"
                @setValue="startDate = $event" />
            </span>
            <span>
              <date-picker-input ref="endDate" :label="$t('user.register_date_to')" :date="endDate"
                @setValue="endDate = $event" />
            </span>

            <v-btn color="primary" @click="searchUser()"> {{ $t("search") }} </v-btn><v-spacer/>
            <span style="margin-right: 10px;">
             <v-btn color="warning" @click="preloadExportCsv" class="">{{ $t("ranking.export_excel") }}</v-btn>
            </span>
            <span>
             <v-btn color="warning" @click="linkToTop50" class="">{{ $t("ranking.top50") }}</v-btn>
              </span>
            </v-row>

        </v-card-actions>
        <br />
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <div style="margin-right: 20px;"><b>{{$t('ranking.role')}}</b></div>
              <div >
              <label  v-for="option in rankList"  :key="option.id" style="margin-right: 30px;vertical-align: center;" >
                <input  type="radio"  :value="option.id" @click="searchUserRadio(option.id)"   v-model="rankSelect" style="margin-right: 3px;"/>{{ option.name }}
              </label>
            </div>
          </v-row>
        </v-card-actions>
        <br />
        <v-card-actions>
          <v-row no-gutters>
            <v-card-title> {{ $t("user.member_list") }} {{ pagination.totalItems }} </v-card-title>
            <v-spacer />

            <span class="px-3 mt-5">{{ $t("search") }}: </span>
            <div style="width: 150px" class="mt-5">
              <v-text-field v-debounce:500ms="searchKeyword" :date="searchData" outlined dense hide-details />
            </div>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :page.sync="pagination.currentPage" :loading="loading" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">
            <template v-slot:[`item.deposit`]="{ item }">
              <div class="amount-col">
                <span class="success--text"> {{ item.deposit | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.withdraw`]="{ item }">
              <div class="amount-col">
                <span class="error--text"> {{ item.withdraw | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.profit`]="{ item }">
              <div class="amount-col">
                <span class="success--text" v-if="(item.profit > 0)"> {{ item.profit | currency }}</span>
                <span class="error--text" v-if="(item.profit < 0)"> {{ item.profit | currency }}</span>
                <span  v-if="(item.profit === 0)"> {{ item.profit | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.bank`]="{ item }">
              <div v-if="!item.bankCountry">
                <img class="pt-3" v-if="item.bank" alt="bank_img" width="25px"
                  :src="require(`@/assets/images/logos/banks/${item.bank}.png`)" />
              </div>
              <div v-else>
                <img class="pt-3" v-if="item.bank" alt="bank_img" width="25px"
                  :src="`https://www.ak47.services/akasset-v2/banks/${item.bankCountry}/${item.bank}.webp`" />
              </div>
              <span>{{ item.bankNumer }}</span>
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { addLogExportCSV } from '@/services/apis/logs'
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      startDate: moment().subtract(3, 'days').format('YY-MM-DD'),
      endDate: moment().format('YY-MM-DD'),
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      searchData: '',
      searchRole:'',
      headers: [
        {
          text: this.$t("ranking.header1"),
          value: 'phone',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2"),
          value: 'name',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header3"),
          value: 'type',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header4"),
          value: 'bank',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header5"),
          value: 'createdat',
          width: '95px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header6"),
          value: 'username',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header7"),
          value: 'deposit',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header8"),
          value: 'withdraw',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header9"),
          value: 'profit',
          align: 'center',
          sortable: false,
        }
      ],
      members: [],
      rankList:[],
      rankSelect:0,
      rank:'',
      loading: false,
      canEdit: true,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
    }
  },

  async created() {
    this.getWebSettingInfo()
    this.getRankingRole()
    this.addLogPage()
  },

  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont) await this.searchPaginate(newValue.page, newValue.itemsPerPage)
      },
      deep: true,
    },
  },

  methods: {
    async getWebSettingInfo() {
      try {
        let settingWebInfo = await this.$store.dispatch('getSettingWebInfo')
        this.bankSystem = settingWebInfo?.bank_system[0] || 'TH';
      } catch (e) { }
    },
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'สมาชิก',
            url: window.location.href,
            detail: 'ระบบแสดงลำดับผู้เล่น',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
      }
    },
    async searchPaginate(page, row) {
      await this.getUsers(page, row, this.startDate, this.endDate, this.searchData)
    },
    async searchUser() {
      await this.getUsers(1, this.pagination.itemsPerPage, this.startDate, this.endDate, this.searchData)
      this.pagination.currentPage = 1
    },
    async searchUserRadio(id) {
      if(id==0){
        this.rank='';
      }else{
        this.rank=id;
      }
      await this.getUsers(1, this.pagination.itemsPerPage, this.startDate, this.endDate, this.searchData)
      this.pagination.currentPage = 1
    },
    async getRankingRole() {
      let rs = await this.$store.dispatch('getRankingRole', {})
      this.rankList=rs.data;
      this.rankList.unshift({
            "id": 0,
            "name": this.$t('ranking.all')
        });
    },
    async getUsers(page, row, time_from, time_to, search) {
      this.loading = true
      this.members = []
      let rs = await this.$store.dispatch('getUserRanking', {
        from:(time_from)?this.formatDateYYYY(time_from):'',
        to:(time_to)?this.formatDateYYYY(time_to):'',
        page: page,
        rows: row,
        search:search,
        rank:this.rank,
      })
      this.pagination.totalItems = rs.count;

      rs.data.forEach(element => {
        this.members.push({
          id: element.id,
          phone: element.phone ? element.phone : '',
          name: element.name ? element.name : '',
          type: element.type ? element.type : '',
          bankCountry: element.bankCountry,
          bank: element.bank,
          bankNumer: element.bank_number,
          username:element.username ? element.username : '',
          createdat: element.createdat,
          rolename: element.rolename ? element.rolename : '',
          deposit: element.deposit,
          withdraw: element.withdraw,
          profit:Math.floor((element.deposit-element.withdraw)*100)/100,
        })
      })
      this.loading = false
    },
    async search() {
      await this.getUsers(this.pagination.page, this.pagination.itemsPerPage, this.dateFrom, this.dateTo)
      this.pagination.currentPage = 1
    },

    linkToTop50() {
      this.$router.push({ name: 'ranking-top50', params: {  } })
    },
    async searchKeyword(value) {
      this.dummy = true;
      this.searchData = value
      await this.getUsers(1, this.pagination.itemsPerPage, null, null, value)
      this.pagination.currentPage = 1
    },
    async preloadExportCsv() {
      await this.addLogExportCSV(true)
      //////// get logExportData ////////
      let logExportData;
      const userSystem = store.getters.getuserInfo
      await axios.get('https://api.ipify.org?format=json').then(res =>
        logExportData = {
          ip: res.data.ip,
          exportPage: 'สมาชิก - ระบบแสดงลำดับของผู้เล่น',
          url: window.location.href,
          detail: 'ระบบแสดงลำดับผุ้เล่น',
          admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
        }
      )

      this.$swal({
        title: `Secure code | รายงาน${logExportData.exportPage}`,
        input: 'password',
        // inputAttributes: {
        //   inputmode: 'numeric',
        //   pattern: '[0-9]*',
        //   maxlength: 6,
        // },
        inputValidator: value => {
          if (!value) {
            return 'โปรดกรอก Secure code'
          }
          // if (value && value.length !== 6) {
          //   return 'โปรดกรอกให้ครบ 6 หลัก'
          // }
        },
        inputPlaceholder: 'ใส่รหัสที่นี่...',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ออก',
      }).then(async result => {
        if (result.isConfirmed) {
          const pin = result.value
          let enterSecureData = {
            ...logExportData,
            keyCheck: pin
          }
          this.loading = true
          let resEnterSecureData = await this.$store.dispatch('checkLogEnterSecure', enterSecureData)
          if (resEnterSecureData && resEnterSecureData.secure) {
            this.exportCsv()
          } else {
            this.$swal.fire('ไม่สามารถ download ได้ เนื่องจากรหัส PIN ไม่ถูกต้อง', '', 'error')
          }
          this.loading = false
        }
      })
    },
    async exportCsv() {
      this.$swal.fire({
        html: this.$t("processing"),
        timerProgressBar: true,
        didOpen: () => { this.$swal.showLoading() }
      })

      let fileName = `${this.$t("ranking.file_name")}_${moment(new Date()).format('YYYY-MM-DD_HH-mm')}`
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const wscols = [
        { wch: 15 },
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];
      let statementlist = []
      let rs = await this.$store.dispatch('getUserRanking', {
        from:(this.startDate)?this.formatDateYYYY(this.startDate):'',
        to:(this.endDate)?this.formatDateYYYY(this.endDate):'',
        page: 1,
        rows: 100000,
        search:this.searchData,
        rank:this.rank,
      })
      // console.log(rs.data);
      rs.data.forEach(element => {
        statementlist.push({
          // id: element.id,
          phone: element.phone ? element.phone : '',
          name: element.name ? element.name : '',
          type: element.type ? element.type : '',
          // bankCountry: element.bankCountry,
          bank: element.bank?element.bank:'',
          bankNumer: element.bank_number?element.bank_number:'',
          RegisterDate: element.createdat,
          username:element.username ? element.username : '',
          // rolename: element.rolename ? element.rolename : '',
          deposit: element.deposit,
          withdraw: element.withdraw,
          profit:Math.floor((element.deposit-element.withdraw)*100)/100,
        })
      })
      let ws = XLSX.utils.json_to_sheet(statementlist);
      ws['!cols'] = wscols;
      const wb = { Sheets: { Ranking: ws }, SheetNames: ["Ranking"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      // add log admin export
      await this.addLogExportCSV()
      this.$swal.close()
    },
    async addLogExportCSV(isClick=false) {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            exportPage: 'สมาชิก - ระบบแสดงลำดับของผู้เล่น',
            url: window.location.href,
            detail: 'ระบบแสดงลำดับผู้เล่น',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
            isClick: isClick,
          }
        )
        await this.$store.dispatch('addLogExportCSV', data)
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
    },
    playSound() {
      this.$store.dispatch('setPlaySound', true)
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
<style scoped>
@media (max-width: 550px) {
  .spacer {
    width: 100%;
  }
}
</style>
